<template>
  <div>
    <b-modal
      :id="modalId"
      body-class="p-0"
      hide-footer
      hide-header
    >
      <div class="block block-rounded block-themed block-transparent mb-0">
        <div class="block-header bg-primary-dark-op">
          <h3 class="block-title">
            Payment
          </h3>
          <div class="block-options">
            <button
              type="button"
              class="btn-block-option"
              @click="$bvModal.hide(modalId)"
            >
              <i class="fa fa-fw fa-times" />
            </button>
          </div>
        </div>
        <b-form @submit.prevent="doSavePaymentAmount">
          <div class="block-content font-size-sm">
            <b-form-group
              label="Consultation Duration (minutes)"
              label-for="form-consult-duration"
            >
              <b-form-input
                id="form-consult-duration"
                v-model="consultDuration"
                class="form-control-alt"
                type="number"
                required
                min="1"
                disabled
              />
            </b-form-group>

            <b-form-group
              label="Payment Amount (USD)"
              label-for="form-payment-amount"
            >
              <b-form-input
                id="form-payment-amount"
                v-model="payAmount"
                class="form-control-alt"
                type="number"
                step="0.01"
                required
                min="1"
                disabled
              />
            </b-form-group>
          </div>
          <div class="block-content block-content-full text-right border-top">
            <small v-if="!canPay">Only expert with completed status can be paid</small>
            <b-button
              variant="alt-primary"
              class="me-1"
              @click="$bvModal.hide(modalId)"
            >
              Close
            </b-button>
            <!--            <b-button variant="primary" type="submit" :disabled="updating || !canPay">
              <b-spinner small v-if="updating"></b-spinner>
              Save
            </b-button>-->
          </div>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'UpdatePaymentBtn',
  props: {
    assignmentId: {
      type: Number,
      required: true,
    },
    assignment:{
      type: Object,
      required: true
    },
    expertId: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      payAmount: this.assignment.value,
      consultDuration: this.assignment.consult_minutes ?? 60,
      updating: false,
    }
  },
  computed: {
    assignmentStatus () {
      return this.assignment.status.name
    },
    modalId () {
      return `expert-payment-modal-${this.assignmentId}`
    },
    canPay () {
      return this.assignmentStatus === 'Completed' || this.assignmentStatus === 'Paid'
    },
  },
  methods: {
    async updateStatus (paidStatus) {
      this.$emit('update-expert-status', paidStatus)
    },
    async doSavePaymentAmount () {
      try {
        this.updating = true
        const result = (await axios.post(`/admin/experts/${this.expertId}/update-payment-amount/${this.assignmentId}`,
            {
              'amount': this.payAmount,
              'duration' : this.consultDuration
            })).data

        await this.updateStatus(result.success.data.paidStatus)
        this.updating = false
        alert(result.success.data.message)
      } catch (e) {
        alert('update failed!')
        console.dir(e)
      } finally {
        this.updating = false
        this.$bvModal.hide(this.modalId)
      }
    },
  },
}
</script>
